import * as React from 'react';
import { idGenerator } from '../../../helpers/idGenerator';
import { Fragment, useMemo, useRef } from 'react';
import { Void } from '../../../models/basic-objects';
import classNames from 'classnames';
import toggleClasses from './Toggle.module.scss';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';

export type ToggleViewProps = {
  //
  checked?: boolean;
  disabled?: boolean;
  formInstance: UseFormReturn;
  helper?: string | JSX.Element;
  id?: string;
  label?: string;
  name: string;
  rules: RegisterOptions;
  toggleHandler: Void;
  wrapper?: boolean;
};

export const ToggleView = (props: ToggleViewProps): JSX.Element => {
  const { disabled, id, name, helper, label, wrapper, formInstance, toggleHandler, rules, checked } = props;
  const inputID = useMemo(() => id ?? idGenerator(name), [id, name]);
  const localRef = useRef<HTMLInputElement | null>(null);
  const { ref: registerRef, ...restRegister } = formInstance.register(name, rules);

  const holderClasses = classNames(toggleClasses.ToggleHolder, {
    [toggleClasses.DisabledToggleSlider]: disabled
  });
  const sliderClasses = classNames(toggleClasses.ToggleSlider, {
    [toggleClasses.ToggleSliderChecked]: checked,
    [toggleClasses.DisabledToggleSliderChecked]: disabled && checked
  });
  const labelContainerClass = classNames(toggleClasses.LabelHolder, {
    [toggleClasses.LabelHolderDisabled]: disabled
  });
  const helperClass = classNames(toggleClasses.HelpText, {
    [toggleClasses.PointerCursor]: !disabled
  });

  let helperElem;

  if (helper) {
    if (typeof helper === 'string') {
      helperElem = (
        <p onClick={!disabled ? () => toggleHandler(checked) : undefined} className={helperClass}>
          {helper}
        </p>
      );
    } else {
      helperElem = <div className={helperClass}>{helper}</div>;
    }
  } else {
    helperElem = null;
  }

  const labelElem = label ? (
    <div className={'cell auto'}>
      <div className={labelContainerClass}>
        <span
          className={!disabled ? toggleClasses.PointerCursor : undefined}
          onClick={!disabled ? () => toggleHandler(checked) : undefined}>
          {label}
        </span>
      </div>
      {helperElem}
    </div>
  ) : null;

  let buffer = (
    <div className={'grid-x align-top'}>
      <div className={'cell shrink'}>
        <div className={holderClasses}>
          <div className={'show-for-sr'}>
            <input
              id={inputID}
              ref={ref => {
                localRef.current = ref;
                registerRef(localRef.current);
              }}
              {...restRegister}
              readOnly
              disabled={disabled}
              value={checked ? 'true' : 'false'}
              type={'text'}
            />
            <label htmlFor={inputID}>{name}</label>
          </div>
          <div onClick={() => toggleHandler(checked)} className={sliderClasses}>
            <span className={'show-for-sr'}>toggle</span>
          </div>
        </div>
      </div>
      {labelElem}
    </div>
  );

  if (wrapper) {
    buffer = <div className={'input-wrapper'}>{buffer}</div>;
  }

  return <Fragment>{buffer}</Fragment>;
};
